// Alert-related constants that can be imported anywhere without circular dependencies

export const TIME_ALERT_PARAM = 'time-alert';

export const ALERT_FREQS = [
  ['10 minutes', '10min'],
  ['30 minutes', '30min'],
  ['1 hour', 'hour'],
  ['1 day', 'day']
];

export const getAlertFreqArr = (freq) => {
  return ALERT_FREQS.find(f => f[1] === freq) || ALERT_FREQS[0];
};

// Time alert templates for maintenance
export const PREVENTATIVE_MAINTENANCE_ALERT_TEMPLATE = {
  param: TIME_ALERT_PARAM,
  data: {
    startDate: new Date(),
    everyXDays: 182,
    recurring: true,
    name: 'Preventative maintenance',
    message: 'Make sure rain bucket is clear of debris. Make sure parts spin freely. Clean clean solar sensor and panel with damp cloth. https://ambientweather.com/faqs/question/view/id/1447/'
  }
};

export const REPLACE_BATTERIES_ALERT_TEMPLATE = {
  param: TIME_ALERT_PARAM,
  data: {
    startDate: new Date(),
    everyXDays: 530,
    recurring: true,
    name: 'Replace Batteries',
    message: 'Time to replace the AA batteries in your outdoor weather array.  We recommend lithium batteries, https://ambientweather.com/faqs/question/view/id/1480/'
  }
};